import { render, staticRenderFns } from "./input-file-item.vue?vue&type=template&id=428836a2&"
import script from "./input-file-item.vue?vue&type=script&lang=js&"
export * from "./input-file-item.vue?vue&type=script&lang=js&"
import style0 from "./input-file-item.vue?vue&type=style&index=0&id=428836a2&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports